import vue from 'vue';
import { createApp } from 'vue';
import memberTab from "../../vue/memberTab.vue"
import $ from "jquery";
import gsap from "gsap";
import ScrollMagic from "ScrollMagic";
import Swiper from 'swiper';

export function load(page){
  if(location.hash){
		let hash = location.hash
		window.onload = function() {
			smoothScroll(hash, 0)
		}
	}

	$('a[href^="#"]:not(js-noscroll)').on('click', function (event) {
		event.preventDefault();
		let href = $(this).attr('href');
		if (href == '#') {
			return
		}
		smoothScroll(href, 0)
	})

    animeInit()
    $(window).resize(function () {
		resize()
	})

	if($('.is-vue').length){
		createApp(memberTab).mount('#vue_member');
	}
}

export function resize(page){
}

function animeInit(){
    let fadein_controller = new ScrollMagic.Controller();
		$('[data-anime]').each(function (index, target_el) {
			let scene = new ScrollMagic.Scene({
				triggerElement: target_el,
				duration: 0,
				triggerHook: 0.9
			}).on('enter', function (event) {
				$(target_el).addClass('is-animeActive')
			}).addTo(fadein_controller)
		})
		$('[data-anime-block]').each(function (index, target_el) {
			let scene = new ScrollMagic.Scene({
				triggerElement: target_el,
				duration: 0,
				triggerHook: 0.8
			}).on("enter", function (event) {
				$(target_el).find('[data-anime-child]').addClass('is-animeActive')
			}).addTo(fadein_controller)
		})
}

function smoothScroll(target_id, offset) {
    if($(target_id).length || target_id != '#top'){
        if($('.js-spnavbtn').hasClass('is-open')){
            $('.js-spnavbtn').removeClass('is-open')
            $('.p-spnav').removeClass('is-open')
        }
        let position;
        let $target_el = $(target_id);
        position = target_id == '#top' ? 0 : $target_el.offset().top;
        let header_size = $('.l-header').height()
		if(!header_size){
			header_size = 0
		}
        $('html,body').animate( {
            scrollTop: (position - header_size)
        }, 600, 'swing' )
    }else if(target_id === '#top'){
		$('html,body').animate( {
            scrollTop: 0
        }, 600, 'swing' )
    }else{
        console.log('smoothScroll no target')
    }
}
